import { Loading } from '../../../loading';

export const withLoading =
  (Component: React.FC<any>) => (props: ILoadingProps) => {
    const isLoading = props.loading ?? false;

    if (!isLoading) return <Component {...props} />;

    return (
      <div className="relative">
        <div className="absolute z-10 top-0 left-0 flex items-center justify-center bg-white/60 w-full h-full">
          <Loading size={40} />
        </div>

        <Component {...props} />
      </div>
    );
  };

export interface ILoadingProps {
  loading?: boolean;
}
